import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ensureScenarioOrRedirect } from '@/lib/utils/planner/ensureScenarioOrRedirect';
import { setLastVisitedScenarioId } from '@/lib/utils/planner/lastVisitedScenario';

const paramsSchema = z.object({
  scenarioId: z.coerce.number().int().positive(),
});

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId')({
  params: paramsSchema,
  beforeLoad: async ({ params: { loopId, scenarioId, org }, context: { queryClient } }) => {
    setLastVisitedScenarioId(loopId, scenarioId);
    await ensureScenarioOrRedirect({ loopId, scenarioId, org, queryClient });
  },
});
